module.exports = __webpack_public_path__ + "img/gtt-marine-logo-horizontal--dark.de916a8e.svg";